import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/logo.png';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import IconButton from '@mui/material/IconButton';

function Navbar({ isLogin, onLogout, data }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <img style={{ padding: '10px' }} src={Logo} alt="Logo" />
        <div className="menu-items">
          <Link to="/">Inicio</Link>
          <div
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', padding: '0 10px 0 10px', height: '100%' }}
            className='menu-button'
          >
            <span id="services-button" role="button" aria-controls={open ? 'services-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={handleClick} style={{ paddingRight: '5px', display: 'flex', alignItems: 'center' }}>
              Servicios
            </span>
            <ArrowDropDownIcon />
          </div>
          <Menu
            id="services-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'services-button',
            }}
          >
            <MenuItem onClick={handleClose} component={Link} to="/services/asistance">Asistencia técnica informática</MenuItem>
            <MenuItem onClick={handleClose} component={Link} to="/services/solution">Solucion profesional</MenuItem>
          </Menu>
          <Link to="/register">Regístrese Ahora</Link>
        </div>
        {isLogin && (
          <>
            <div className='right-aligned'>
              <span style={{marginRight: '20px'}}>{data?.telefono} | Konecta</span>
              <IconButton color="inherit" onClick={onLogout}>
                <PowerSettingsNewIcon />
              </IconButton>
            </div>
          </>
          )}
      </div>
    </nav>
  );
}

export default Navbar;